import moment from 'moment-timezone';
import { Sensor } from '../models/sensor/sensor';

export class GraphUtils {
  static bubleSort(arr) {
    var i, j;
    var len = arr.length;
    var isSwapped = false;
    for (i = 0; i < len; i++) {
      isSwapped = false;
      for (j = 0; j < len; j++) {
        if (arr[j + 1] != undefined) {
          if (arr[j][0] > arr[j + 1][0]) {
            var temp = arr[j]
            arr[j] = arr[j + 1];
            arr[j + 1] = temp;
            isSwapped = true;
          }
        }
      }

      // IF no two elements were swapped by inner loop, then break
      if (!isSwapped) {
        break;
      }
    }
    return arr
  }

  static getMaxValue(series, ranges, limits) {
    const ChartValues = series;
    let maxValue = null;
    for (const arrays of ChartValues) {
      for (const value of arrays.data) {
        if (value[1] > maxValue || maxValue == null) {
          maxValue = value[1];
        }
      }
    }

    // if (ranges.length > 0) {
    //   const maxRangeValue = ranges.reduce(function (prev, current) {
    //     return (prev.to > current.to) ? prev : current
    //   });

    //   if ((maxRangeValue && maxRangeValue.to > maxValue) || maxValue == null) {
    //     maxValue = maxRangeValue.to;
    //   }
    // }

    return maxValue ?? 0;
  }

  static getMinValue(series, ranges, limits) {
    const ChartValues = series;
    let minValue = null;
    for (const arrays of ChartValues) {
      for (const value of arrays.data) {
        if (value[1] < minValue || minValue == null) {
          minValue = value[1];
        }
      }
    }

    // if (ranges.length > 0) {
    //   const minRangeValue = ranges.reduce(function (prev, current) {
    //     return (prev.from > current.from) ? current : prev
    //   });

    //   if ((minRangeValue && minRangeValue.from < minValue) || minValue == null) {
    //     minValue = minRangeValue.from;
    //   }
    // }

    return minValue ?? 0;
  }

  static getMinDate(series) {
    let minDate = null;
    for (const arrays of series) {
      for (const value of arrays.data) {
        if ((value[0] < minDate) || (minDate == null)) {
          minDate = value[0];
        }
      }
    }
    return minDate;
  }

  static getMaxDate(series) {
    let maxDate = null;
    for (const arrays of series) {
      for (const value of arrays.data) {
        if ((value[0] > maxDate) || (maxDate == null)) {
          maxDate = value[0];
        }
      }
    }
    return maxDate;
  }

  static getDateUtc(date) {
    return Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    );
  }

  static getDay(date) {
    return Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
    );
  }

  static getMoth(date) {
    return Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      1,
      0,
      0,
      0,
    );
  }

  static getHour(date) {
    return Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      0,
      0,
    );
  }

  static convertDecimals(value) {
    if (value && !Number.isInteger(value)) {
      return Math.round((value + Number.EPSILON) * 100) / 100;
    }

    return value;
  }

  static getGroundData(element, sensor) {
    return {
      conductivity: GraphUtils.convertDecimals(sensor.conductivity),
      temperature: GraphUtils.convertDecimals(sensor.temperature),
      water: GraphUtils.convertDecimals(sensor.water),
      extSat: GraphUtils.convertDecimals(sensor.extSat),
      date: element.date,
      position: element.sensors.indexOf(sensor),
    };
  }

  static getTensiometerData(element, sensor) {
    return {
      pressure: GraphUtils.convertDecimals(sensor.pressure),
      date: element.date,
      position: element.sensors.indexOf(sensor),
    };
  }

  static getAmbientalData(element, sensor) {
    return {
      temperature: GraphUtils.convertDecimals(sensor.temperature),
      humidity: GraphUtils.convertDecimals(sensor.humidity),
      dpv: GraphUtils.convertDecimals(sensor.dpv),
      preasure: GraphUtils.convertDecimals(sensor.preasure) ?? null,
      dewPoint: GraphUtils.convertDecimals(sensor.dewPoint),
      date: element.date,
      position: element.sensors.indexOf(sensor),
    };
  }

  static getPluviometerData(element, sensor) {
    return {
      water: GraphUtils.convertDecimals(sensor.value) ?? 0,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getPulseData(element, sensor) {
    return {
      water: sensor.value ?? 0,
      waterRegister: sensor.waterRegister ?? null,
      equivalence: sensor.equivalence ?? 1,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getLevelData(element, sensor) {
    return {
      preassure:    GraphUtils.convertDecimals(sensor.preassure) ?? 0,
      water:        sensor.water        != null ? GraphUtils.convertDecimals(sensor.water)        : null,
      waterPercent: sensor.waterPercent != null ? GraphUtils.convertDecimals(sensor.waterPercent) : null,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getHumidityData(element, sensor) {
    return {
      temperature: GraphUtils.convertDecimals(sensor.temperature) ?? 0,
      humidity: GraphUtils.convertDecimals(sensor.humidity) ?? 0,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getWaterPotencialData(element, sensor) {
    return {
      temperature: GraphUtils.convertDecimals(sensor.temperature) ?? 0,
      preassure: GraphUtils.convertDecimals(sensor.preassure) ?? 0,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getPreassureData(element, sensor) {
    return {
      preassure: GraphUtils.convertDecimals(sensor.preassure) ?? 0,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getNpkData(element, sensor) {
    return {
      nitrogen: GraphUtils.convertDecimals(sensor.nitrogen) ?? 0,
      phosphorus: GraphUtils.convertDecimals(sensor.phosphorus) ?? 0,
      potassium: GraphUtils.convertDecimals(sensor.potassium) ?? 0,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getPhData(element, sensor) {
    return {
      ph: GraphUtils.convertDecimals(sensor.ph) ?? 0,
      temperature: GraphUtils.convertDecimals(sensor.temperature) ?? 0,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getWcData(element, sensor) {
    return {
      conductivity: GraphUtils.convertDecimals(sensor.conductivity) ?? 0,
      temperature: GraphUtils.convertDecimals(sensor.temperature) ?? 0,
      position: element.sensors.indexOf(sensor),
      date: element.date,
    }
  }

  static getAtmos22Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const { position = 1 } = sensorBd.find(s => s.id === sensor.sensorId) || {};

    return {
      windSpeed: GraphUtils.convertDecimals(sensor.windSpeed) ?? 0,
      windDirection: GraphUtils.convertDecimals(sensor.windDirection) ?? 0,
      airTemperature: GraphUtils.convertDecimals(sensor.airTemperature) ?? 0,
      position: position - 1,
      date: localDate,
    }
  }

  static getIg31Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const { position = 1 } = sensorBd.find(s => s.id === sensor.sensorId) || {};
    return {
      soilMoisture: GraphUtils.convertDecimals(sensor.soilMoisture) ?? 0,
      soilEc: GraphUtils.convertDecimals(sensor.soilEc) ?? 0,
      soilTemperature: GraphUtils.convertDecimals(sensor.soilTemperature) ?? 0,
      position: position - 1,
      date: localDate,
    }
  }
  static getIg71Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const { position = 1 } = sensorBd.find(s => s.id === sensor.sensorId) || {};
    return {
      airTemperature: GraphUtils.convertDecimals(sensor.airTemperature) ?? 0,
      humidity: GraphUtils.convertDecimals(sensor.humidity) ?? 0,
      atmPressure: GraphUtils.convertDecimals(sensor.atmPressure) ?? 0,
      position: position - 1,
      date: localDate,
    }
  }

  static getMec10Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const { position = 1 } = sensorBd.find(s => s.id === sensor.sensorId) || {};

    return {
      soilMoisture: GraphUtils.convertDecimals(sensor.soilMoisture) ?? 0,
      soilEc: GraphUtils.convertDecimals(sensor.soilEc) ?? 0,
      soilTemperature: GraphUtils.convertDecimals(sensor.soilTemperature) ?? 0,
      position: position - 1,
      date: localDate,
    }
  }

  static getWnk80ma_010Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const { position = 1 } = sensorBd.find(s => s.id === sensor.sensorId) || {};
    return {
      matricPotential: GraphUtils.convertDecimals(sensor.matricPotential) ?? 0,
      position: position - 1,
      date: localDate,
    }
  }

  static getWnk80ma_05Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const { position = 1 } = sensorBd.find(s => s.id === sensor.sensorId) || {};
    return {
      matricPotential: GraphUtils.convertDecimals(sensor.matricPotential) ?? 0,
      position: position - 1,
      date: localDate,
    }
  }

  static getAcclimaTdr315hData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const { position = 1 } = sensorBd.find(s => s.id === sensor.sensorId) || {};
    return {
      soilTemperature: GraphUtils.convertDecimals(sensor.soilTemperature) ?? 0,
      soilMoisture: GraphUtils.convertDecimals(sensor.soilMoisture) ?? 0,
      soilEc: GraphUtils.convertDecimals(sensor.soilEc) ?? 0,
      position: position - 1,
      date: localDate,
    }
  }

  //En variables los nuevos sensores
  static getMatricPotencialData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      matricPotential: GraphUtils.convertDecimals(sensor.matricPotential) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getwindSpeedData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      windSpeed: GraphUtils.convertDecimals(sensor.windSpeed) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getWindDirectionData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      windDirection: GraphUtils.convertDecimals(sensor.windDirection) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getAirTemperatureData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      airTemperature: GraphUtils.convertDecimals(sensor.airTemperature) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getSoilTemperatureData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    const result: any = {
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    };

    if (sensor.soilTemperature !== undefined) {
      result.soilTemperature1 = GraphUtils.convertDecimals(sensor.soilTemperature) ?? 0;
    }

    if (sensor.soilTemperature1 !== undefined) {
      result.soilTemperature1 = GraphUtils.convertDecimals(sensor.soilTemperature1) ?? 0;
    }
    if (sensor.soilTemperature2 !== undefined) {
      result.soilTemperature2 = GraphUtils.convertDecimals(sensor.soilTemperature2) ?? 0;
    }
    if (sensor.soilTemperature3 !== undefined) {
      result.soilTemperature3 = GraphUtils.convertDecimals(sensor.soilTemperature3) ?? 0;
    }
    if (sensor.soilTemperature4 !== undefined) {
      result.soilTemperature4 = GraphUtils.convertDecimals(sensor.soilTemperature4) ?? 0;
    }
    if (sensor.soilTemperature5 !== undefined) {
      result.soilTemperature5 = GraphUtils.convertDecimals(sensor.soilTemperature5) ?? 0;
    }
    if (sensor.soilTemperature6 !== undefined) {
      result.soilTemperature6 = GraphUtils.convertDecimals(sensor.soilTemperature6) ?? 0;
    }
    if (sensor.soilTemperature7 !== undefined) {
      result.soilTemperature7 = GraphUtils.convertDecimals(sensor.soilTemperature7) ?? 0;
    }
    if (sensor.soilTemperature8 !== undefined) {
      result.soilTemperature8 = GraphUtils.convertDecimals(sensor.soilTemperature8) ?? 0;
    }

    return result;
  }


  static getSoilPhData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      soilPh: GraphUtils.convertDecimals(sensor.soilPh) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getSoilMoistureData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    const result: any = {
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    };

    if (sensor.soilMoisture !== undefined) {
      result.soilMoisture1 = GraphUtils.convertDecimals(sensor.soilMoisture) ?? 0;
    }
    if (sensor.soilMoisture1 !== undefined) {
      result.soilMoisture1 = GraphUtils.convertDecimals(sensor.soilMoisture1) ?? 0;
    }
    if (sensor.soilMoisture2 !== undefined) {
      result.soilMoisture2 = GraphUtils.convertDecimals(sensor.soilMoisture2) ?? 0;
    }
    if (sensor.soilMoisture3 !== undefined) {
      result.soilMoisture3 = GraphUtils.convertDecimals(sensor.soilMoisture3) ?? 0;
    }
    if (sensor.soilMoisture4 !== undefined) {
      result.soilMoisture4 = GraphUtils.convertDecimals(sensor.soilMoisture4) ?? 0;
    }
    if (sensor.soilMoisture5 !== undefined) {
      result.soilMoisture5 = GraphUtils.convertDecimals(sensor.soilMoisture5) ?? 0;
    }
    if (sensor.soilMoisture6 !== undefined) {
      result.soilMoisture6 = GraphUtils.convertDecimals(sensor.soilMoisture6) ?? 0;
    }
    if (sensor.soilMoisture7 !== undefined) {
      result.soilMoisture7 = GraphUtils.convertDecimals(sensor.soilMoisture7) ?? 0;
    }
    if (sensor.soilMoisture8 !== undefined) {
      result.soilMoisture8 = GraphUtils.convertDecimals(sensor.soilMoisture8) ?? 0;
    }
    return result;
  }



  static getSoilEcData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      soilEc: GraphUtils.convertDecimals(sensor.soilEc) ?? 0,
      extSat: GraphUtils.convertDecimals(sensor.extSat) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getRadiationData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      radiation: GraphUtils.convertDecimals(sensor.radiation) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getParFarRedData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      parFarRed: GraphUtils.convertDecimals(sensor.parFarRed) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getFarRedData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      farRed: GraphUtils.convertDecimals(sensor.farRed) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getPriData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      pri: GraphUtils.convertDecimals(sensor.pri) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getGerbilXp02Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      soilTemperature1: GraphUtils.convertDecimals(sensor.soilTemperature1) ?? 0,
      soilTemperature2: GraphUtils.convertDecimals(sensor.soilTemperature2) ?? 0,
      soilMoisture1: GraphUtils.convertDecimals(sensor.soilMoisture1) ?? 0,
      soilMoisture2: GraphUtils.convertDecimals(sensor.soilMoisture2) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }


  static getHumidityDataAttribute(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      humidity: GraphUtils.convertDecimals(sensor.humidity) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getAtmPressureData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      atmPressure: GraphUtils.convertDecimals(sensor.atmPressure) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getCntTotalData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      cntTotal: GraphUtils.convertDecimals(sensor.cntTotal) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getCntParcialData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      cntParcial: GraphUtils.convertDecimals(sensor.cntParcial) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getCntParcialCumulativeData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      cntParcial: GraphUtils.convertDecimals(sensor.cntParcial) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getTipoSenAbatData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      tipoSenAbat: GraphUtils.convertDecimals(sensor.tipoSenAbat) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getWaterEcData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      waterEc: GraphUtils.convertDecimals(sensor.waterEc) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getWaterTemperatureData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      waterTemperature: GraphUtils.convertDecimals(sensor.waterTemperature) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getDepthData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      depth: GraphUtils.convertDecimals(sensor.depth) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getCalWatsData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      calWats: GraphUtils.convertDecimals(sensor.calWats) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getCo2Data(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      co2: GraphUtils.convertDecimals(sensor.co2) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getCondData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      cond: GraphUtils.convertDecimals(sensor.cond) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getTempData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      temp: GraphUtils.convertDecimals(sensor.temp) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getPhDataAttribute(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      ph: GraphUtils.convertDecimals(sensor.ph) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getRawData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      raw: GraphUtils.convertDecimals(sensor.raw) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getDewPointObjectData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      dewPoint: GraphUtils.convertDecimals(sensor.dewPoint) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getDpvData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      dpv: GraphUtils.convertDecimals(sensor.dpv) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getWaterPluviometerData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      water: GraphUtils.convertDecimals(sensor.water) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getWaterCounterPulseData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    const cntParcial = sensor.cntParcial ?? 0;
    const equivalence = sensor.equivalence ?? (cntParcial !== 0 ? sensor.water / cntParcial : 1);
    return {
      water: sensor.water ?? 0,
      cntTotal: GraphUtils.convertDecimals(sensor.cntTotal) ?? 0,
      cntParcial: GraphUtils.convertDecimals(cntParcial) ?? 0,
      waterRegister: sensor.waterRegister ?? null,
      equivalence,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getLeafTemperatureData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      leafTemperature: GraphUtils.convertDecimals(sensor.leafTemperature) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getLeafWetnessData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      leafWetness: GraphUtils.convertDecimals(sensor.leafWetness) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }
  static getVoltageData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      voltage: GraphUtils.convertDecimals(sensor.voltage) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getPressureDataAttribute(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      pressure: GraphUtils.convertDecimals(sensor.pressure) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getWaterLevelData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      waterLevel: GraphUtils.convertDecimals(sensor.waterLevel) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getMilliAmpsData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      milliAmps: GraphUtils.convertDecimals(sensor.milliAmps) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getWaterData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      water: GraphUtils.convertDecimals(sensor.water) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getWaterEmbalseData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      water: GraphUtils.convertDecimals(sensor.water) ?? 0,
      waterPercent: sensor.waterPercent ?? null,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getVaporPressureData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      vaporPressure: GraphUtils.convertDecimals(sensor.vaporPressure) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }

  static getPrecipitationData(element, sensor, sensorBd, positionOneNode) {
    const localDate = moment.utc(element.date).tz(sensor.timezone).format();
    const found = sensorBd.find(s => s.id === sensor.sensorId);
    const position = found?.position ?? positionOneNode ?? 1;
    return {
      precipitationEC: GraphUtils.convertDecimals(sensor.precipitationEC) ?? 0,
      position: position - 1,
      date: localDate,
      type: sensor.type ?? 0,
    }
  }


}
